// eslint-disable-next-line
// @ts-nocheck
import { i18n } from '@/lang/i18n';
import { pinia } from '@/store';
import { useCommonStore } from '@/store/common';
import { isPC, isHK } from '@/utils/tools';

const { t } = i18n.global;
const commonStore = useCommonStore(pinia);

// 通用路由 10个
const common = [
  {
    path: '/',
    component: isHK()
      // exchange.hashkey.com 专属首页
      ? () => import('@/pages/home/IndexHK.vue')
      : () => import('@/pages/home/Index.vue'),
    meta: {
      layout: 'default',
      props: { header: { theme: 'light', border: false, fixed: true }, footer: { theme: 'light', border: false } },
      title: t('tdk_home_meta_title'),
      description: t('tdk_home_meta_description'),
      keywords: t('tdk_home_meta_keywords'),
      ssg: {
        preload: [commonStore.getSymbols, commonStore.getCurrency]
      }
    },
    redirect: !isPC() ? '/h5/hkhome' : ''
  },
  {
    path: '/h5/hkhome',
    component: () => import('@/pages/home/hkh5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_home_meta_title'),
      description: t('tdk_home_meta_description'),
      keywords: t('tdk_home_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/agreement',
    component: () => import('@/pages/home/hkh5/Agreement.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_h5_agreement_meta_title'),
      description: t('tdk_h5_agreement_meta_description'),
      keywords: t('tdk_h5_agreement_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/register',
    component: () => import('@/pages/register/Index.vue'),
    meta: {
      layout: 'login',
      title: t('注册账号 - HashKey Exchange数字资产平台'),
      description: t('立即注册HashKey Exchange，使用港币、美元买卖比特币、以太坊等热门数字资产，享受快速、安全、合规的交易服务。'),
      keywords: t('HashKey Exchange, 注册数字货币账户, 数字资产开户, 港币买币, 美元买币, 数字货币交易平台'),
      ssg: {}
    }
  },
  {
    path: '/register/invite',
    component: () => import('@/pages/register/invite/Invite.vue'),
    meta: {
      // 此页面为h5的被邀请人注册页面
      layout: 'h5Default',
      title: t('tdk_register_invite_meta_title'),
      description: t('tdk_register_invite_meta_description'),
      keywords: t('tdk_register_invite_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/wx/download',
    component: () => import('@/pages/download/wechat/Index.vue'),
    meta: {
      layout: '',
      title: t('tdk_h5_wx_download_meta_title'),
      description: t('tdk_h5_wx_download_meta_description'),
      keywords: t('tdk_h5_wx_download_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/download',
    component: () => import('@/pages/appDownload/web/Index.vue'),
    meta: {
      layout: 'default',
      props: { footer: { theme: 'dark', margin: false } },
      title: t('tdk_download_meta_title'),
      description: t('tdk_download_meta_description'),
      keywords: t('tdk_download_meta_keywords'),
      ssg: {}
    },
    redirect: !isPC() ? '/h5/download' : ''
  },
  {
    path: '/h5/imToken',
    component: () => import('@/pages/imToken/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_imtoken_meta_title'),
      description: t('tdk_imtoken_meta_description'),
      keywords: t('tdk_imtoken_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/download',
    component: () => import('@/pages/appDownload/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_download_meta_title'),
      description: t('tdk_download_meta_description'),
      keywords: t('tdk_download_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/login',
    component: () => import('@/pages/login/Index.vue'),
    meta: {
      layout: 'login',
      title: t('tdk_login_meta_title'),
      description: t('tdk_login_meta_description'),
      keywords: t('tdk_login_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/modify-password',
    component: () => import('@/pages/login/ModifyPassword.vue'),
    meta: {
      layout: 'login',
      title: t('tdk_modify_password_meta_title'),
      description: t('tdk_modify_password_meta_description'),
      keywords: t('tdk_modify_password_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/reset-password',
    component: () => import('@/pages/reset-password/Layout.vue'),
    meta: {
      layout: 'login',
      title: t('tdk_reset_password_meta_title'),
      description: t('tdk_reset_password_meta_description'),
      keywords: t('tdk_reset_password_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/auth',
    component: () => import('@/pages/auth/Index.vue'),
    meta: {
      layout: '',
      title: t('tdk_auth_meta_title'),
      description: t('tdk_auth_meta_description'),
      keywords: t('tdk_auth_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/freeze',
    component: () => import('@/pages/freeze/Index.vue'),
    meta: {
      layout: '',
      props: { header: { border: false } },
      title: t('现在登录 - HashKey Global - 买币更方案，存币更安心'),
      ssg: {}
    },
    redirect: !isPC() ? '/h5/freeze' : ''
  },
  {
    path: '/h5/freeze',
    component: () => import('@/pages/freeze/Index.vue'),
    meta: {
      layout: '',
      props: { header: { border: false } },
      title: t('现在登录 - HashKey Global - 买币更方案，存币更安心'),
      ssg: {}
    },
    redirect: isPC() ? '/freeze' : ''
  },
  {
    path: '/support-fee',
    component: () => import('@/pages/support/feeIndex.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_supportfee_meta_title'),
      description: t('tdk_supportfee_meta_description'),
      keywords: t('tdk_supportfee_meta_keywords'),
      props: {
        header: {
          class: 'm-width-1440 mobile-header'
        },
        default: {
          isPC: true
        },
        footer: {
          class: 'm-width-1440 mobile-footer'
        }
      }
      // ssg: {}
    },
    redirect: !isPC() ? '/h5/support-fee' : ''
  },
  {
    path: '/h5/support-fee',
    component: () => import('@/pages/support/feeIndex.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_supportfee_meta_title'),
      description: t('tdk_supportfee_meta_description'),
      keywords: t('tdk_supportfee_meta_keywords')
      // ssg: {}
    },
    props: {
      default: {
        isPC: false
      }
    },
    redirect: isPC() ? '/support-fee' : ''
  },
  {
    path: '/official-verification',
    component: () => import('@/pages/official-verification/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('HashKey 官方渠道验证'),
      ssg: {}
    },
    redirect: !isPC() ? '/h5/official-verification' : ''
  },
  {
    path: '/h5/official-verification',
    component: () => import('@/pages/official-verification/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('HashKey 官方渠道验证'),
      ssg: {}
    },
    redirect: !isPC() ? '' : '/official-verification'
  },
  {
    path: '/contactUs',
    component: () => import('@/pages/contactUs/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_contactUs_meta_title'),
      description: t('tdk_contactUs_meta_description'),
      keywords: t('tdk_contactUs_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/blog',
    component: () => import('@/pages/blog/index.vue'),
    meta: {
      layout: 'default',
      // props: { footer: { margin: false } },
      title: t('tdk_blog_meta_title'),
      description: t('tdk_blog_meta_description'),
      keywords: t('tdk_blog_meta_keywords'),
      ssg: {}
    }
    // redirect: !isPC() ? '/h5/blog' : ''
  },
  {
    path: '/blog/:id',
    component: () => import('@/pages/blog/detail.vue'),
    meta: {
      layout: 'default',
      // props: { footer: { margin: false } },
      title: t('tdk_blog_meta_title'),
      description: t('tdk_blog_meta_description'),
      keywords: t('tdk_blog_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/blog',
    component: () => import('@/pages/blog/h5/index.vue'),
    meta: {
      layout: 'h5Default',
      // props: { footer: { margin: false } },
      title: t('tdk_blog_meta_title'),
      description: t('tdk_blog_meta_description'),
      keywords: t('tdk_blog_meta_keywords'),
      ssg: {}
    }
    // redirect: isPC() ? '/blog' : ''
  },
  {
    path: '/h5/blog/:id',
    component: () => import('@/pages/blog/h5/detail.vue'),
    meta: {
      layout: 'blank',
      title: t('tdk_blog_meta_title'),
      description: t('tdk_blog_meta_description'),
      keywords: t('tdk_blog_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/nps',
    component: () => import('@/pages/nps/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('nps_title'),
      auth: 'login',
      ssg: {}
    },
    redirect: !isPC() ? '/h5/nps' : ''
  },
  {
    path: '/nps/qa',
    component: () => import('@/pages/nps/web/QA.vue'),
    meta: {
      layout: 'default',
      title: t('nps_title'),
      auth: 'login',
      ssg: {}
    },
    redirect: !isPC() ? '/h5/nps/qa' : ''
  },
  {
    path: '/nps/result',
    component: () => import('@/pages/nps/web/Result.vue'),
    meta: {
      layout: 'default',
      title: t('nps_title'),
      auth: 'login',
      ssg: {}
    },
    redirect: !isPC() ? '/h5/nps/result' : ''
  },
  {
    path: '/h5/nps',
    component: () => import('@/pages/nps/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('nps_title'),
      ssg: {}
    },
    redirect: isPC() ? '/nps' : ''
  },
  {
    path: '/h5/nps/qa',
    component: () => import('@/pages/nps/h5/QA.vue'),
    meta: {
      layout: 'h5Default',
      title: t('nps_title'),
      ssg: {}
    },
    redirect: isPC() ? '/nps/qa' : ''
  },
  {
    path: '/h5/nps/result',
    component: () => import('@/pages/nps/h5/Result.vue'),
    meta: {
      layout: 'h5Default',
      title: t('nps_title'),
      ssg: {}
    },
    redirect: isPC() ? '/nps/result' : ''
  },
  {
    path: '/how-to-buy',
    component: () => import('@/pages/howToBuy/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('how_to_buy_title'),
      description: t('how_to_buy_description'),
      keywords: t('how_to_buy_keywords'),
      ssg: {}
    },
    redirect: !isPC() ? '/h5/how-to-buy' : ''
  },
  {
    path: '/h5/how-to-buy',
    component: () => import('@/pages/howToBuy/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('how_to_buy_title'),
      description: t('how_to_buy_description'),
      keywords: t('how_to_buy_keywords'),
      ssg: {}
    },
    redirect: isPC() ? '/how-to-buy' : ''
  },
  {
    path: '/how-to-buy/:name',
    component: () => import('@/pages/howToBuy/web/detail/Index.vue'),
    beforeEnter: (to, from, next) => {
      const { name } = to.params;
      const tokenName = name.replace(/-/g, ' ');
      if (name) {
        to.meta.title = t('how_to_buy_detail_title', { currency: tokenName });
        to.meta.description = t('how_to_buy_detail_description', { currency: tokenName });
        to.meta.keywords = t('how_to_buy_detail_keywords', { currency: tokenName });
        next(isPC() ? undefined : { path: `/h5/how-to-buy/${name}`, params: { name } });
      } else {
        next('/how-to-buy');
      }
    },
    meta: {
      layout: 'default',
      ssg: {}
    }
  },
  {
    path: '/h5/how-to-buy/:name',
    component: () => import('@/pages/howToBuy/h5/detail/Index.vue'),
    beforeEnter: (to, from, next) => {
      const { name } = to.params;
      const tokenName = name.replace(/-/g, ' ');
      if (name) {
        to.meta.title = t('how_to_buy_detail_title', { currency: tokenName });
        to.meta.description = t('how_to_buy_detail_description', { currency: tokenName });
        to.meta.keywords = t('how_to_buy_detail_keywords', { currency: tokenName });
        next(isPC() ? { path: `/how-to-buy/${name}`, params: { name } } : undefined);
      } else {
        next('/h5/how-to-buy');
      }
    },
    meta: {
      layout: 'h5Default',
      ssg: {}
    }
  }
];

export default common;
